import { render, staticRenderFns } from "./shopEdit.vue?vue&type=template&id=67fde56e&scoped=true&"
import script from "./shopEdit.vue?vue&type=script&lang=js&"
export * from "./shopEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67fde56e",
  null
  
)

export default component.exports